import { useTranslate } from '@tolgee/react';
import { GetStaticProps } from 'next';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import Container from '@amf/shared/components/layout/Container';
import ContactSend from '@amf/shared/components/contact/ContactSend';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';

interface ContactPageProps extends NavigationProps {}

export default function ContactPage({ navigation, partners }: ContactPageProps) {
  const { t } = useTranslate();
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}>
      <div className='ContactPage'>
        <Layout navigation={navigation} partners={partners}>
          <Meta title={t('contact.title')} />
          <Container>
            <h1>{t('contact.title')}</h1>
            <div className='ContactPage__content'>
              <ContactSend buttonProps={{ variant: 'dark' }} />
              <div className='ContactPage__info'>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.info.title')}</h2>
                  <address>
                    Malý fotbal Brno, z.s.
                    <br />
                    Jihlavská 7a, 625 00 Brno
                  </address>
                  <p>
                    <a href='mailto:info@malyfotbalbrno.cz'>info@malyfotbalbrno.cz</a>
                    <br />
                    <a href='tel:+420602725382'>+420 602 725 382</a>
                  </p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.billing.title')}</h2>
                  <address>
                    <strong>Malý fotbal Brno, z.s.</strong>
                    <br />
                    Jihlavská 7a
                    <br />
                    625 00 Brno
                  </address>
                  <p>IČ: 26642441</p>
                  <p>{t('contact.billing.account')}: 190994025/0300</p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.social.title')}</h2>
                  <p>
                    <a
                      href='https://www.facebook.com/profile.php?id=100063485323675'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Facebook
                    </a>
                    <br />
                    <a
                      href='https://www.instagram.com/malyfotbalbrno/'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Instagram
                    </a>
                    <br />
                    <a href='https://sport.video/bsmk' target='_blank' rel='noreferrer'>
                      Online zápasy
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </Container>
        </Layout>
      </div>
    </GoogleReCaptchaProvider>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
    revalidate: 10,
  };
};
